"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldMetaType = void 0;
var tslib_1 = require("tslib");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
exports.FormFieldMetaType = prop_types_1.default.shape({
    error: prop_types_1.default.string,
    valid: prop_types_1.default.bool,
    touched: prop_types_1.default.bool,
});
//# sourceMappingURL=FormFieldMetaType.js.map